module.exports = __webpack_public_path__ + "static/media/Raw_fish.015cbb7e.png";